import { useGetLimits, useResetUsage, useUpdateLimits } from './useApiLimit'

export const apiLimit = {
  get: useGetLimits,
  update: useUpdateLimits,
  resetUsage: useResetUsage,
}
